(function (upp) {
    'use strict';

    upp.controller('upp.restaurant.CategoryCtrl', ['$scope', '$routeParams', 'restaurantService', 'cartService', 'appi',
            function ($scope, $routeParams, restaurantService, cartService, appi) {

                appi.ui.changeActualOption({moduleKey2Display: 'restaurant', navbarKey: 'restaurant'});
                appi.ui.showPageLoadingMsg();

                $scope.content = [];

                if ($routeParams.id > 0) {
                    restaurantService.getFoods($routeParams.id).then(function(data) {
                        $scope.content = data.foods;
                        $scope.currency = data.currency;
                        $scope.categoryName = data.categoryName;
                        $scope.addToBasket = data.addToBasket;
                        appi.ui.hidePageLoadingMsg();
                    });
                } else {
                    // mocked
                    appi.ui.hidePageLoadingMsg();
                }

                $scope.tryAdd2cart = function (product) {
                    if (product.attributes.length > 1){
                        appi.location.path('/restaurant/food/' + product.id);
                    } else {
                        product.selectedVariation = product.attributes[0];
                        product.selectedVariation.priceFinal = product.selectedVariation.price;
                        product.selectedStock = 1;
                        cartService.add(product, $scope.currency);
                    }
                };
            }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/restaurant/controllers/category-controller.js